//* 组件库
import { utility } from "various-ui";
//* 工具属性
import type { DisposePosOption, DividingRule, DrawingData } from "./src/types";

//* 类型
export * from "./src/types";

//* 绘图工具类
export class DrawingUtils {
    //? 坐标的开始位置
    begin = 1;

    //? 计算当前点位的位置
    disposePos(site: number, data: DrawingData[], option: DisposePosOption) {
        //* 查找数据列表中是否存在该点坐标
        const origin = data.find((value) => value.start <= site && value.end >= site);

        //* 检测是否满足运行条件
        if (!origin) return { offset: 0, data: {} as any };
        else {
            //* 初始化返回数据
            const ratio = origin?.ratio || option.ratio || 0;
            const result = { offset: (site - origin.start) * ratio, data: origin };

            //* 遍历统计坐标前面分区的尺寸
            const befores = data.filter((value) => value.start >= this.begin && value.start < (origin?.start || 0)) || [];
            befores.forEach((value) => {
                result.offset += value.size * (value.ratio || option.ratio || 0);
            });

            //* 根据align进行坐标偏移
            switch (option.align) {
                case "right": {
                    result.offset += ratio;
                    return result;
                }

                case "center": {
                    result.offset += ratio / 2;
                    return result;
                }

                default:
                    return result;
            }
        }
    }
}

//* 刻度尺计算
export const dividingRule = (maxValue: number, divisions: number[]): DividingRule => {
    //* 峰值小于等于0或数组过滤后为空退出
    if (maxValue <= 0 || !divisions.filter((value) => value > 0).length) return { value: 1, number: 1, scales: [1], decimals: 0 };
    //* 数据初始化
    const strs = maxValue.toString().split(".");
    const result = { value: 0, number: 0, scales: [] as number[], decimals: 0 };
    const config = { flag: true, value: 0, number: 0, division: 0 };

    //* 校验函数
    const verifyValue = (data: number, number: number) => {
        const result = { number: 0, data: [] as number[] };
        const division = utility.divide(data, number);
        for (let ib = 1; ib <= number; ib++) {
            const value = division * ib;
            const valueFormat = value
                .toString()
                .replace(/^[0\.]+/, "")
                .replace(/[0\.]+$/, "");
            if (valueFormat.length > result.number) result.number = valueFormat.length;
            if (valueFormat.length == 1 || (valueFormat.length == 2 && valueFormat.charAt(1) == "5")) {
                result.data.push(value);
                continue;
            } else {
                return;
            }
        }

        return result;
    };

    //* 检测峰值是大于1还是小于1, 进行处理
    if (strs[0] == "0") {
        config.division = utility.divide(1, Math.pow(10, (strs[1]?.match(/^0+/)?.[0]?.length || 0) + 2));
        config.value = utility.multiply(Math.floor(maxValue / config.division), config.division);
    } else {
        config.division = Math.pow(10, Math.max(strs[0].length - 2, 0));
        config.value = Math.ceil(maxValue / config.division) * config.division;
    }

    //* 无限循环
    while (config.flag) {
        //* 遍历刻度数组, 检测是否符合要求
        const number = utility.add(config.value, utility.multiply(config.division, config.number));
        for (let i = 0; i < divisions.length; i++) {
            const verifyResult = verifyValue(number, divisions[i]);
            if (verifyResult) {
                config.flag = false;
                result.value = number;
                result.number = divisions[i];
                result.scales = verifyResult.data;
                result.decimals = verifyResult.number;
                break;
            }
        }

        //* 检测峰值超过1且每次自增小于1时, 梯度更新
        if (number >= 1 && config.division < 1) {
            config.value = 1;
            config.number = 0;
            config.division = 1;
        } else {
            config.number++;
        }
    }

    return result;
};
